import Aos from 'aos'
// import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react'
import Head from "next/head";
import Script from 'next/script'
import SrollTop from '../components/common/ScrollTop'
import { useDispatch, useSelector } from 'react-redux'
import ErrorBoundary from '../components/ErrorBoundary'
import { fetchCoreConfig } from '../redux/slices/user'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/scrollbar'
import 'swiper/css/effect-cards'
import 'aos/dist/aos.css'
import '../styles/index.scss'
import '../pages/sign-in/sign-in.css'
import '../pages/sign-in/otpInput.css'
import '../styles/index.css'
// import { Provider } from "react-redux";
import { SessionProvider } from 'next-auth/react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { Provider as ReduxProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store, persistor } from '../redux/store'
import { useRouter } from 'next/router'
import * as gtag from '../utils/gtag'
import CookieConsent from '../components/cookies/CookieConsent'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import 'rsuite/dist/rsuite-no-reset.min.css';
import { Inter } from 'next/font/google'
import { usePathname } from 'next/navigation'

import dotenv from 'dotenv';
dotenv.config();

if (typeof window !== 'undefined') {
  require('bootstrap/dist/js/bootstrap')
}

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-primary',
})

const customTheme = createTheme({
  typography: {
    fontFamily: [
      'var(--font-primary)',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      '"Noto Sans"',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
    ].join(', '),
  },
  components: {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Change to your desired color
          width: '20px',
          height: '20px'
        }
      }
    }
  }
})

// 🔹 Ensures API Call on App Load
function AppInitializer({ setIsConfigLoaded }) {
  const dispatch = useDispatch()
  const { configData } = useSelector(state => state.user)

  useEffect(() => {
    dispatch(fetchCoreConfig()) // Fetch config data

    // Check if data is fetched
    if (configData) {
      setIsConfigLoaded(true) // Hide loader when configData is available
    }
  }, [dispatch, configData])

  return null
}

function Loading({ isConfigLoaded }) {
  return !isConfigLoaded ? (
    <div className='loading-indicator'>
      <div className='loader'></div>
    </div>
  ) : null
}

export default function App({
  Component,
  pageProps: { session, ...pageProps }
}) {
  const router = useRouter()
  const [isConfigLoaded, setIsConfigLoaded] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    Aos.init({
      duration: 1200,
      once: true
    })
  }, [])

  useEffect(() => {
    const handleRouteChange = url => {
      gtag.pageview(url)
    }
    // console.log("CheckMount:")
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
      // console.log("CheckClear:")
    }
  }, [router.events])

  // const DynamicComponent = dynamic(() => import(`../pages/${pageProps.page}`), {
  //   loading: () => <Loading />
  // });

  useEffect(() => {
    const handleDeepLink = () => {
      const currentUrl = window.location.href

      if (currentUrl.includes('https://royalsmartlifestyle.com/')) {
        const urlParams = new URLSearchParams(window.location.search)
        const mobileParam = urlParams.get('mobile')

        if (mobileParam) {
          // Decode the mobile value from Base64
          const decodedValue = atob(mobileParam)

          // Check if the decoded value equals "true"
          if (decodedValue === 'true') {
            const userAgent =
              navigator.userAgent || navigator.vendor || window.opera
            const isAndroid = /android/i.test(userAgent)
            const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

            const appStoreLink =
              'https://apps.apple.com/in/app/rsl-rides-hotels-flights/id1351219496'
            const playStoreLink =
              'https://play.google.com/store/apps/details?id=com.rsl.luxurycab.passenger&hl=en'

            const timeout = 1000
            let timer

            // Start a timer to redirect to the app store if the app doesn't open after 2 seconds
            timer = setTimeout(() => {
              if (isAndroid && shouldShowPlayStore()) {
                window.location.href = playStoreLink
              } else if (isIOS) {
                window.location.href = appStoreLink
              }
            }, timeout)

            // Clear the timer if the user switches to the app (blur event)
            const clearTimer = () => clearTimeout(timer)
            window.addEventListener('blur', clearTimer)

            // Cleanup the event listener on component unmount
            return () => window.removeEventListener('blur', clearTimer)
          }
        }
      }
    }

    handleDeepLink()
  }, [])

  return (
    <main className={inter.variable}>
      <Head>
        <title>Royalsmartlifestyle - Tour & Travel</title>
      </Head>
      <Script
        strategy='afterInteractive'
        src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`}
      />
      <Script
        id='gtag-init'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtag.GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `
        }}
      />

      {
        pathname === '/property-enquiry' ? null : (
          <div
            className='whatsapp_float'
          >
            <div className='dropdown dropup dropstart d-md-block'>
              <button
                className='btn btn-success rounded-circle d-flex align-items-center justify-content-center whatsapp_float_size'

                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                <WhatsAppIcon />
              </button>

              <ul className='dropdown-menu dropdown-menu-end shadow mb-4 whatsapp_float_menu rounded border-0'>
                <li className="dropdown-header px-3 py-2 text-muted small fw-semibold">
                  Contact via WhatsApp
                </li>

                <li>
                  <a
                    className='dropdown-item d-flex align-items-center gap-2 py-2 px-3'
                    href="https://wa.me/+97143977746"
                    target='_blank'
                    rel='noreferrer'
                  >
                    <WhatsAppIcon className="text-success" />
                    <span>Royal Smart Limousine</span>
                  </a>
                </li>

                <li><hr className="dropdown-divider my-1" /></li>

                <li>
                  <a
                    className='dropdown-item d-flex align-items-center gap-2 py-2 px-3'
                    href="https://wa.me/+97142885603"
                    target='_blank'
                    rel='noreferrer'
                  >
                    <WhatsAppIcon className="text-success" />
                    <span>Royal Smart Lifestyle</span>
                  </a>
                </li>
              </ul>

            </div>
          </div>)
      }



      <ThemeProvider theme={customTheme}>
        <SessionProvider session={session}>
          <ReduxProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <AppInitializer setIsConfigLoaded={setIsConfigLoaded} />
              {/* Ensures API Call */}
              <Loading isConfigLoaded={isConfigLoaded} />
              {/* Loader Until Data Loads */}
              {!isConfigLoaded ? null : (
                <MainApp Component={Component} pageProps={pageProps} />
              )}
              {/* <ErrorBoundary> */}
              {/* <CookieConsent /> */}

              <SrollTop />
            </PersistGate>
          </ReduxProvider>
        </SessionProvider>
      </ThemeProvider>
    </main>
  )
}

function MainApp({ Component, pageProps }) {
  const { configData } = useSelector(state => state.user) // Now it will work properly

  return <Component {...pageProps} />
}
